var map = {
	"./Dan.jpeg": "5546",
	"./Ida.jpeg": "e7f7",
	"./Johanna.jpeg": "7b55",
	"./Karl.jpeg": "3fe0",
	"./Tomas.jpeg": "b736",
	"./imp.jpeg": "b1c6",
	"./maskin.jpeg": "8d5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "39de";